/** Document title + admin header labels from route paths. */

const USER_TITLES = [
  { test: (p) => p === '/login', title: 'Welcome Back — Properties Infinite' },
  { test: (p) => p === '/' || p === '', title: 'Properties Infinite' },
  { test: (p) => p.startsWith('/property/'), title: 'Property Details — Properties Infinite' },
  { test: (p) => p === '/account', title: 'Profile — Properties Infinite' },
  { test: (p) => p === '/properties', title: 'Browse Properties — Properties Infinite' },
  { test: (p) => p === '/contact', title: 'Contact Us — Properties Infinite' },
  { test: (p) => p === '/privacy-policy', title: 'Privacy Policy — Properties Infinite' },
  { test: (p) => p === '/terms', title: 'Terms & Conditions — Properties Infinite' },
  { test: (p) => p.startsWith('/property/create'), title: 'Post Property — Properties Infinite' },
  { test: (p) => p.startsWith('/project/create'), title: 'Post Project — Properties Infinite' },
];

const ADMIN_SEGMENT_TITLES = {
  dashboard: 'Dashboard',
  chat: 'User Chat',
  'unknown-user': 'Unknown User',
  'chat-notifications': 'Chat Notifications',
  'chat-configuration': 'Chat Configuration',
  'partner-chat': 'Partner Chat',
  'user-chat': 'User Chat',
  properties: 'All Listings',
  'my-listings': 'My Listings',
  'my-properties': 'Own Properties',
  'awaiting-listings': 'Awaiting Approval',
  'sold-out-properties': 'Sold Out Properties',
  'create-listing': 'Create Listing',
  'own-property': 'Add Own Property',
  'own-project': 'Add Own Project',
  partners: 'Partner Management',
  users: 'User List',
  admins: 'Admin List',
  config: 'Web Config',
  'config-language': 'Web Config Edit Language',
  localization: 'Localization',
  'security-settings': 'Security Settings',
  bookings: 'Booking List',
  enquiries: 'Enquiry List',
  'user-web-contacts': 'User Web Contact List',
  'partner-requests': 'Partner Requests',
  'kyc-document-types': 'KYC Document Types',
  'partner-kyc-requests': 'Partner KYC Requests',
  login: 'Admin Login',
};

function matchUserTitle(pathname) {
  const p = pathname || '/';
  const hit = USER_TITLES.find((r) => r.test(p));
  return hit?.title || 'Properties Infinite';
}

function matchPortalTitle(pathname, portalLabel) {
  const parts = (pathname || '').split('/').filter(Boolean);
  const segment = parts[1] || 'dashboard';
  const page = ADMIN_SEGMENT_TITLES[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  return `${page} — ${portalLabel}`;
}

export function getPageTitle(pathname) {
  const p = pathname || '/';
  if (p.startsWith('/partner')) {
    if (p === '/partner/login') return 'Partner Login — Properties Infinite';
    return matchPortalTitle(p, 'PIF Partner');
  }
  if (p.startsWith('/admin')) {
    if (p === '/admin/login') return 'Admin Login — Properties Infinite';
    return matchPortalTitle(p, 'PIF Admin');
  }
  return matchUserTitle(p);
}

export function getAdminHeaderTitle(pathname, basePath = '/admin') {
  const p = pathname || '';
  const prefix = basePath.replace(/\/$/, '');
  const segment = p.replace(prefix, '').split('/').filter(Boolean)[0] || 'dashboard';
  return ADMIN_SEGMENT_TITLES[segment] || 'PIF Admin';
}
